// extracted by mini-css-extract-plugin
export var linkText = "_nq-0";